import { createReducer } from 'zeal-redux-utils'

function isApolloAction(action) {
  return /^APOLLO_/.test(action.type)
}

export default function(initialState, handlers) {
  return createReducer(initialState, handlers, {
    allowNonStandardActionIf: isApolloAction
  })
}



// WEBPACK FOOTER //
// ./client/modules/util/createReducer.js